import { UserRoleE } from './../../models/enums';
// values for the filterType query param
export const categoryOptions = (userRole?: UserRoleE) => [
    { value: 'advertiser', label: 'Advertiser Name' },
    (userRole === UserRoleE.GlobalAdmin || userRole === UserRoleE.GlobalAdminAndAdminContentManager)
        ? { value: 'advertiserId', label: 'Advertiser ID' }
        : null,
    { value: 'advertisingagency', label: 'Advertising agency' },
    { value: 'brand', label: 'Brand' },
    { value: 'broadcaster', label: 'Broadcaster' },
    { value: 'mediacompany', label: 'Media Company' },
    { value: 'campaignNumber', label: 'Campaign number' },
    { value: 'name', label: 'Campaign name' },
    { value: 'number', label: 'Project (delivery) number' },
    { value: 'projectcomment', label: 'Description' },
    (userRole === UserRoleE.GlobalAdmin || userRole === UserRoleE.GlobalAdminAndAdminContentManager || userRole === UserRoleE.Broadcaster)
        ? { value: 'housenumber', label: 'House number' }
        : undefined,
    (userRole === UserRoleE.GlobalAdmin || userRole === UserRoleE.PostProduction)
        ? { value: 'internalnumber', label: 'Internal project number' }
        : undefined,
    { value: 'postproduction', label: 'Post/sound production' },
    { value: 'supplier', label: 'Production company' },
    { value: 'participantnames', label: 'Presentor' },
    { value: 'speakernames', label: 'Speaker Names' },
    { value: 'productionlocation', label: 'Production location' },
    { value: 'versionAdid', label: 'Version ADID' },
    { value: 'version', label: 'Version name' },
    { value: 'industry', label: 'Market category' },
].filter(option => option);

export const campaignCategoryOptions = [
    // { value: 'advertiserId', label: 'Advertiser ID' },
    // { value: 'advertisingagency', label: 'Advertising agency' },
    // { value: 'brand', label: 'Brand' },
    // { value: 'broadcaster', label: 'Broadcaster' },
    { value: 'name', label: 'Campaign name' },
    { value: 'campaignNumber', label: 'Campaign number' },
    // { value: 'participantnames', label: 'Presentor' },
    // { value: 'number', label: 'Project (delivery) number' },
    // { value: 'speakernames', label: 'Speaker Names' },
];